
// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_API_KEY,
//     authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_ID
// };
const firebaseConfig = {
    apiKey: "AIzaSyC3UpQc4SC_aGQvIzaQnmA_qjZ51pkV25g",
    authDomain: "bike-shop-a290e.firebaseapp.com",
    projectId: "bike-shop-a290e",
    storageBucket: "bike-shop-a290e.appspot.com",
    messagingSenderId: "470720576480",
    appId: "1:470720576480:web:6c35ddfba33a1a3b080985"
};



export default firebaseConfig;